import React, { useState, useEffect } from "react";
import { gql, useApolloClient } from "@apollo/client";
import AsyncSelect from "react-select/async";

const GET_LOCATIONS = gql`
  query GetLocations($inputPattern: String) {
    facilities(
      where: {_or: [
        {city: {_ilike: $inputPattern}},
        {zipcode: {_ilike: $inputPattern}}
      ]},
      distinct_on: [city, zipcode],
      order_by: [{city: asc}, {zipcode: asc}]
    ) {
      zipcode
      city
      state
    }
  }
`;

const mapGraphQlResultsToOptions = (facilities, filterValues) => {
  filterValues = Array.isArray(filterValues) ? filterValues : null;
  return facilities.filter((facility) => {
    return ! Array.isArray(filterValues) || filterValues.includes(facility.zipcode);
  }).map((facility) => ({
    value: facility.zipcode,
    label: `${facility.city}, ${facility.state} ${facility.zipcode}`
  }));
};

const fetchLocationOptions = async (client, inputValue) => {
  inputValue = (inputValue || '').replace(/\W+/g, '');
  const inputPattern = `${inputValue}%`;
  return client.query({ query: GET_LOCATIONS, variables: { inputPattern } }).then((results) => {
    if (results.data && results.data.facilities) {
      return mapGraphQlResultsToOptions(results.data.facilities);
    } else {
      return [];
    }
  });
};

const LocationSelect = (props) => {
  const client = useApolloClient();
  const [selectedValues, setSelectedValues] = useState([]);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const localProps = { ...props };
  delete(localProps.searchParams);
  const passedOnChange = typeof(localProps.onChange) === 'function' ? localProps.onChange : null;
  delete(localProps.onChange);

  useEffect(() => {
    client.query({ query: GET_LOCATIONS, variables: { inputPattern: '%' } }).then((results) => {
      if (results.data && results.data.facilities) {
        const options = mapGraphQlResultsToOptions(results.data.facilities);
        setDefaultOptions(options);
        const filterValues = props.searchParams && props.searchParams.has('zipcode') && props.searchParams.get('zipcode').trim().length > 0 ?
          props.searchParams.get('zipcode').trim().split(/\s*,\s*/) : [];
        setSelectedValues(options.filter((option) => filterValues.includes(option.value)));
      }
    });
  }, [client, props.searchParams]);

  return (
    <AsyncSelect
      isMulti
      cacheOptions
      loadOptions={(inputValue) => {
        return fetchLocationOptions(client, inputValue);
      }}
      hideSelectedOptions
      isSearchable
      placeholder="Select one or more locations…"
      {...localProps}
      defaultOptions={defaultOptions}
      value={selectedValues}
      onChange={(selectedOptions) => {
        setSelectedValues(selectedOptions);
        if (passedOnChange) {
          passedOnChange(selectedOptions);
        }
      }}
    />
  );
};

export default LocationSelect;
